import * as React from 'react';

interface OwnProps {}

export const Spinner: React.StatelessComponent<OwnProps> = () => (
    <div className="g-spinner" />
);
